import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../assets/loading.gif'
import _imports_1 from '../../assets/error.jpg'


const _hoisted_1 = { ref: "audioRef" }
const _hoisted_2 = {
  key: 0,
  class: "audio-player-mobile"
}
const _hoisted_3 = { class: "audio-player-mobile-playlist" }
const _hoisted_4 = { class: "audio-player-mobile-playlist-scrolled" }
const _hoisted_5 = { class: "audio-player-mobile-playlist-table" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "audio-player-mobile-playlist-table-name" }
const _hoisted_8 = { class: "audio-player-mobile-playlist-table-rating" }
const _hoisted_9 = { class: "audio-player-mobile-playlist-table-duration" }
const _hoisted_10 = { class: "audio-player-mobile-audio-controls" }
const _hoisted_11 = { class: "audio-player-mobile-audio-controls-panel" }
const _hoisted_12 = { class: "audio-player-mobile-audio-controls-buttons" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "audio-player-mobile-audio-controls-panel" }
const _hoisted_16 = { class: "audio-player-mobile-audio-controls-rating" }
const _hoisted_17 = { class: "audio-player-mobile-audio-timewrap" }
const _hoisted_18 = { class: "audio-player-mobile-audio-timewrap-currenttime" }
const _hoisted_19 = { class: "audio-player-mobile-audio-timewrap-duration" }
const _hoisted_20 = { class: "flip-card-inner" }
const _hoisted_21 = { class: "flip-card-front" }
const _hoisted_22 = {
  key: 0,
  class: "audio-player-mobile-audio-image"
}
const _hoisted_23 = {
  key: 0,
  src: _imports_0,
  id: "019f7473-7285-752a-85d2-4e5c9f77c481"
}
const _hoisted_24 = {
  key: 1,
  class: "audio-player-mobile-audio-image"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  id: "019f7473-7285-752a-85d2-4e5c9f77c481"
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 2,
  class: "audio-player-mobile-audio-image"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "flip-card-back" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 1,
  class: "audio-player-desktop"
}
const _hoisted_40 = { class: "audio-player-desktop-controls" }
const _hoisted_41 = { class: "audio-player-desktop-controls-buttons" }
const _hoisted_42 = { class: "audio-player-desktop-controls-volume-timewrap" }
const _hoisted_43 = { class: "audio-player-desktop-playlist" }
const _hoisted_44 = { class: "audio-player-desktop-playlist-table" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "audio-player-desktop-playlist-table-name" }
const _hoisted_47 = { class: "audio-player-desktop-playlist-table-rating" }
const _hoisted_48 = { class: "audio-player-desktop-playlist-table-duration" }
const _hoisted_49 = { class: "audio-player-desktop-audio-controls" }
const _hoisted_50 = { class: "audio-player-desktop-audio-controls-panel" }
const _hoisted_51 = { class: "audio-player-desktop-audio-controls-buttons" }
const _hoisted_52 = { class: "audio-player-desktop-audio-controls-rating" }
const _hoisted_53 = { class: "audio-player-desktop-audio-timewrap" }
const _hoisted_54 = { class: "audio-player-desktop-audio-timewrap-currenttime" }
const _hoisted_55 = { class: "audio-player-desktop-audio-timewrap-duration" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = ["src"]
const _hoisted_61 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_audio_rating_2 = _resolveComponent("audio-rating-2")!
  const _component_audio_rating_active_2 = _resolveComponent("audio-rating-active-2")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("audio", _hoisted_1, null, 512),
    (_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("table", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playList, (audioFile, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: audioFile.id,
                    class: _normalizeClass(["audio-player-mobile-playlist-table-tr", _ctx.checkStateFile(audioFile.id)]),
                    onClick: ($event: any) => (_ctx.selectAudioTrack(audioFile))
                  }, [
                    _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.formatTrackTitl(audioFile.title, index)), 1),
                    _createElementVNode("td", _hoisted_8, [
                      _createVNode(_component_audio_rating_2, {
                        rating: audioFile.rating,
                        fileId: audioFile.id
                      }, null, 8, ["rating", "fileId"])
                    ]),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.getAudioFileLastDuration(+audioFile.duration)), 1)
                  ], 10, _hoisted_6))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "mobile-control-audio-icon icon-add",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addAll()))
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "mobile-control-audio-icon icon-audio-back",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
                    })
                  ]),
                  (_ctx.globalState === 3)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "mobile-control-audio-icon icon-audio-pause",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.pause && _ctx.pause(...args)))
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("li", _hoisted_14, [
                        _createElementVNode("a", {
                          href: "#",
                          class: "mobile-control-audio-icon icon-audio-play",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.play(0)))
                        })
                      ])),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "mobile-control-audio-icon icon-audio-forward",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.forward && _ctx.forward(...args)))
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#",
                      class: _normalizeClass(["mobile-control-audio-icon icon-loop", _ctx.loop? 'mobile-control-icon-active' : '']),
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.loopHandle && _ctx.loopHandle(...args)))
                    }, null, 2)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#",
                      class: _normalizeClass(["mobile-control-audio-icon icon-shuffle", _ctx.shuffle? 'mobile-control-icon-active' : '']),
                      onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.shuffleHandle && _ctx.shuffleHandle(...args)))
                    }, null, 2)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "mobile-control-audio-icon icon-gift",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.gift()))
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "mobile-control-audio-icon icon-clear",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clearPlaylist()))
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_audio_rating_active_2, {
                  rating: _ctx.playingRating,
                  fileId: _ctx.playingId,
                  onSetRating: _ctx.changeRating
                }, null, 8, ["rating", "fileId", "onSetRating"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", null, _toDisplayString(_ctx.currentTimeFormatted), 1)
              ]),
              _createElementVNode("div", {
                class: "audio-player-mobile-audio-timewrap-progressbar",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.audioProgressbar && _ctx.audioProgressbar(...args)))
              }, [
                _createElementVNode("div", {
                  class: "bar",
                  style: _normalizeStyle({ width: _ctx.progressPersent + '%' })
                }, null, 4)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("span", null, _toDisplayString(_ctx.durationFormatted), 1)
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: "flip-card",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggleFlip()))
          }, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                (_ctx.globalState === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      (_ctx.globalState === 1)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                        : _createCommentVNode("", true)
                    ]))
                  : (_ctx.globalState === 5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                    : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        (_ctx.playingAlbumId > 0)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: 'https://backend.vdmar.ru/storage/images/'+_ctx.playingAlbumId+'/1.jpg',
                              id: "019f7473-7285-752a-85d2-4e5c9f77c481"
                            }, null, 8, _hoisted_28))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: 'https://backend.vdmar.ru/storage/images/1/white.jpg',
                              id: "019f7473-7285-752a-85d2-4e5c9f77c481"
                            }, null, 8, _hoisted_29))
                      ]))
              ]),
              _createElementVNode("div", _hoisted_30, [
                (_ctx.playingAlbumId > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createTextVNode(_toDisplayString(_ctx.playingFile.genre), 1),
                      _hoisted_32,
                      _createTextVNode(" " + _toDisplayString(_ctx.playingFile.artist), 1),
                      _hoisted_33,
                      _createTextVNode(" " + _toDisplayString(_ctx.playingFile.album), 1),
                      _hoisted_34,
                      _createTextVNode(" " + _toDisplayString(_ctx.playingFile.year), 1),
                      _hoisted_35,
                      _createTextVNode(" " + _toDisplayString(_ctx.playingFile.title), 1),
                      _hoisted_36,
                      _createTextVNode(" Количество прослушиваний: " + _toDisplayString(_ctx.playingFile.count), 1),
                      _hoisted_37,
                      _createTextVNode(" Последний раз: " + _toDisplayString(_ctx.playingFile.lastPlayed), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_38))
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("ul", _hoisted_41, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "#",
                  class: "control-icon icon-add",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addAll()))
                })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "#",
                  class: "control-icon icon-clear",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.clearPlaylist()))
                })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "#",
                  class: "control-icon icon-gift",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.gift()))
                })
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass(["control-icon icon-shuffle", _ctx.shuffle? 'control-icon-active' : '']),
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.shuffleHandle && _ctx.shuffleHandle(...args)))
                }, null, 2)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass(["control-icon icon-loop", _ctx.loop? 'control-icon-active' : '']),
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.loopHandle && _ctx.loopHandle(...args)))
                }, null, 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", {
                class: "volume_progressbar",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.volumeProgressbar && _ctx.volumeProgressbar(...args)))
              }, [
                _createElementVNode("div", {
                  class: "bar",
                  style: _normalizeStyle({ width: _ctx.volumePersent + '%' })
                }, null, 4)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", {
              class: "audio-player-desktop-playlist-scrolled",
              style: _normalizeStyle(_ctx.styleObjectList)
            }, [
              _createElementVNode("table", _hoisted_44, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playList, (audioFile, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: audioFile.id,
                    class: _normalizeClass(["audio-player-desktop-playlist-table-tr", _ctx.checkStateFile(audioFile.id)]),
                    onClick: ($event: any) => (_ctx.selectAudioTrack(audioFile))
                  }, [
                    _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.formatTrackTitl(audioFile.title, index)), 1),
                    _createElementVNode("td", _hoisted_47, [
                      _createVNode(_component_audio_rating_2, {
                        rating: audioFile.rating,
                        fileId: audioFile.id
                      }, null, 8, ["rating", "fileId"])
                    ]),
                    _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.getAudioFileLastDuration(+audioFile.duration)), 1)
                  ], 10, _hoisted_45))
                }), 128))
              ])
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "control-icon icon-audio-back",
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#",
                      class: _normalizeClass(["control-icon icon-audio-play", (_ctx.globalState === 3)? 'control-icon-active' : '']),
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.play(0)))
                    }, null, 2)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#",
                      class: _normalizeClass(["control-icon icon-audio-pause", (_ctx.globalState === 4)? 'control-icon-active' : '']),
                      onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.pause && _ctx.pause(...args)))
                    }, null, 2)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#",
                      class: _normalizeClass(["control-icon icon-audio-stop", (_ctx.globalState === 0)? 'control-icon-active' : '']),
                      onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.stop && _ctx.stop(...args)))
                    }, null, 2)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "control-icon icon-audio-forward",
                      onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.forward && _ctx.forward(...args)))
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createVNode(_component_audio_rating_active_2, {
                  rating: _ctx.playingRating,
                  fileId: _ctx.playingId,
                  onSetRating: _ctx.changeRating
                }, null, 8, ["rating", "fileId", "onSetRating"])
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("span", null, _toDisplayString(_ctx.currentTimeFormatted), 1)
              ]),
              _createElementVNode("div", {
                class: "audio-player-desktop-audio-timewrap-progressbar",
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.audioProgressbar && _ctx.audioProgressbar(...args)))
              }, [
                _createElementVNode("div", {
                  class: "bar",
                  style: _normalizeStyle({ width: _ctx.progressPersent + '%' })
                }, null, 4)
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("span", null, _toDisplayString(_ctx.durationFormatted), 1)
              ])
            ])
          ]),
          (_ctx.globalState === 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "audio-player-desktop-audio-image",
                style: _normalizeStyle(_ctx.styleObjectCover)
              }, _hoisted_57, 4))
            : (_ctx.globalState === 5)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "audio-player-desktop-audio-image",
                  style: _normalizeStyle(_ctx.styleObjectCover)
                }, _hoisted_59, 4))
              : (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "audio-player-desktop-audio-image",
                  style: _normalizeStyle(_ctx.styleObjectCover)
                }, [
                  (_ctx.playingAlbumId > 0)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: 'https://backend.vdmar.ru/storage/images/'+_ctx.playingAlbumId+'/1.jpg'
                      }, null, 8, _hoisted_60))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        src: 'https://backend.vdmar.ru/storage/images/1/white.jpg'
                      }, null, 8, _hoisted_61))
                ], 4))
        ]))
  ], 64))
}